var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuAdminPanel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  id: "AdminPanel_1_",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  overflow: "visible",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "#FFFFFF",
  d: "M17,22c-2.03,0-3.82-1.01-4.9-2.55c-0.52,0.23-1.05,0.42-1.6,0.55 C6.2,18.97,3,14.72,3,10.18V5.27L10.5,2L18,5.27v4.82c2.84,0.48,5,2.94,5,5.91C23,19.31,20.31,22,17,22z M16,6.58l-5.5-2.4L5,6.58 v3.6c0,3.5,2.33,6.74,5.5,7.74c0.25-0.08,0.49-0.19,0.73-0.3C11.08,17.11,11,16.56,11,16c0-2.97,2.16-5.43,5-5.91V6.58z M17,12 c-2.21,0-4,1.79-4,4s1.79,4,4,4s4-1.79,4-4S19.21,12,17,12z M17,18.75c-0.92,0-1.74-0.46-2.24-1.17c0.05-0.72,1.51-1.08,2.24-1.08 s2.19,0.36,2.24,1.08C18.74,18.29,17.92,18.75,17,18.75z M17,15.62c-0.62,0-1.12-0.5-1.12-1.12s0.5-1.12,1.12-1.12 c0.62,0,1.12,0.5,1.12,1.12S17.62,15.62,17,15.62z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuAdminPanel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_AdminPanel.94ba6083.svg";
export { ForwardRef as ReactComponent };